import { z } from 'zod';
import {
  dateSchema,
  datetimeLocalSchema,
  modelSchema,
} from '../base';

const baseGoalSchema = z.object({
  title: z.string(),
  status: z.enum(['open', 'done']),
  doneAtLocal: datetimeLocalSchema.nullable(),
  doneAt: dateSchema.nullable(),
  parentGoalId: z.guid().nullable(),
});

const goalStateValidation = (goal: {
  status: 'open' | 'done';
  doneAt: Date | null;
  doneAtLocal: string | null;
}) => {
  if (goal.status === 'done') {
    return goal.doneAt !== null && goal.doneAtLocal !== null;
  } else {
    return goal.doneAt === null && goal.doneAtLocal === null;
  }
};

export const goalSchema = baseGoalSchema.extend(modelSchema.shape).refine(
  goalStateValidation,
  {
    message: 'Invalid goal state: status and done fields are inconsistent',
  },
);

export const goalUpdateSchema = baseGoalSchema
  .omit({ parentGoalId: true })
  .partial()
  .refine(
    (update) => {
      // If status isn't being updated, or if any done-related fields aren't defined,
      // skip validation as it will be handled during the operation
      if (update.status === undefined) {
        return true;
      }
      return goalStateValidation(update as z.infer<typeof baseGoalSchema>);
    },
    {
      message: 'Invalid goal update: status and done fields are inconsistent',
    },
  );

export const goalCreateSchema = baseGoalSchema
  .extend({
    id: z.guid(),
    parentGoalId: z.guid().nullable().optional(),
  })
  .refine(goalStateValidation, {
    message: 'Invalid goal creation: status and done fields are inconsistent',
  });
